import * as Yup from 'yup';
import { CPF_CNPJ_REGEX, FORMAT_DATETIME_REGEX } from 'v3/utils/masks';

export const NewOccurrencesSchema = Yup.object().shape({
  occurrenceType: Yup.object()
    .required('Tipo de ocorrência obrigatório')
    .typeError('Tipo de ocorrência obrigatório'),
  responsible: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
      })
    )
    .min(1)
    .max(5, 'Máximo de 5 grupos')
    .required('Grupo Responsável obrigatório')
    .typeError('Grupo Responsável obrigatório'),
  description: Yup.string().when('occurrenceType', {
    is: (occurrenceType) =>
      !['DELIVERY', 'DELIVERY_LOCATION_NOT_FOUND',
        'DELIVERY_LOCATION_CLOSED',
        'SCHEDULED_DELIVERY',
        'DEPARTURE_FOR_DELIVERY',
        'DAMAGE'].includes(occurrenceType?.slug),
    then: (schema) =>
      schema
        .required('Descrição obrigatória')
        .max(2000, 'Máximo de 2000 caracteres'),
    otherwise: (schema) => schema.notRequired(),
  }),
  startDate: Yup.string()
    .required('Forneça uma data válida')
    .test('validDateTime', 'Forneça uma data válida', value => {
      return FORMAT_DATETIME_REGEX.test(value);
    }),
  endDate: Yup.string()
    .nullable()
    .test('validDateTime', 'Forneça uma data válida', value => {
      if (!value) return true;
      return FORMAT_DATETIME_REGEX.test(value);
    }),
});

export const OccurrencesOboticatioDelivery = Yup.object().shape({
  receiverName: Yup.string()
    .required('Nome do recebedor obrigatório')
    .max(200, 'Máximo de 200 caracteres'),
  typeReceiverId: Yup.number()
    .required('Tipo de recebedor obrigatório')
    .typeError('Tipo de destinatário obrigatório'),
  docReceiver: Yup.string()
    .required('Documento do recebedor obrigatório')
    .matches(CPF_CNPJ_REGEX, 'Documento deve estar no formato válido de CPF ou CNPJ'),
  currentDeliveryId: Yup.number()
    .required('Entrega atual obrigatório')
    .typeError('Entrega atual obrigatório'),
  cteId: Yup.number().required('CT-e obrigatório'),
  nfeIds: Yup.array()
    .nullable()
    .test('is-array', 'NF-e obrigatório', (value) => Array.isArray(value))
    .required('NF-e obrigatório')
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
      })
    )
    .min(1, 'NF-e obrigatório')

});

export const validateAttachmentsSchema = Yup.object().shape({
  files: Yup.array()
    .required('Anexo obrigatório')
    .test('is-array', 'Anexo obrigatório', (value) => Array.isArray(value))
    .min(1, 'Anexo obrigatório'),
})

export const OccurrencesOboticatio = Yup.object().shape({
  currentDeliveryId: Yup.number()
    .required('Entrega atual obrigatório')
    .typeError('Entrega atual obrigatório'),
  cteId: Yup.number().required('CT-e obrigatório'),
  nfeIds: Yup.array()
    .nullable()
    .test('is-array', 'NF-e obrigatório', (value) => Array.isArray(value))
    .required('NF-e obrigatório')
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
      })
    )
    .min(1, 'NF-e obrigatório'),
});

export const DescriptionSchema = Yup.object().shape({
  description: Yup.string()
    .required('Descrição obrigatória')
    .max(2000, 'Máximo de 2000 caracteres'),
  startDate: Yup.string()
    .required('Forneça uma data válida')
    .test('validDateTime', 'Forneça uma data válida', value => {
      return FORMAT_DATETIME_REGEX.test(value);
    }),
  endDate: Yup.string()
    .nullable()
    .test('validDateTime', 'Forneça uma data válida', value => {
      if (value === null || value === undefined || value === '') {
        return true;
      }
      if (!FORMAT_DATETIME_REGEX.test(value)) {
        return false;
      }
      return true;
    })
});


export const AnullSchema = Yup.object().shape({
  description: Yup.string()
    .required('Motivo da anulação obrigatório')
    .max(2000, 'Máximo de 2000 caracteres')
    .min(30, 'Mínimo de 30 caracteres'),
});

export const ChangeResponsibleSchema = Yup.object().shape({
  responsible: Yup.array()
    .of(Yup.object().shape({ id: Yup.number().required() }))
    .max(5, 'Máximo de 5 grupos')
    .required('Grupo Responsável obrigatório')
    .typeError('Grupo Responsável obrigatório'),
  description: Yup.string()
    .required('Descrição obrigatória')
    .max(2000, 'Máximo de 2000 caracteres'),
});

export const AttachmentDescriptionSchema = Yup.object().shape({
  description: Yup.string()
    .max(127, 'Máximo de 127 caracteres')
    .required('Descrição obrigatória'),
});

export const EndLotOccurrenceSchema = Yup.object().shape({
  description: Yup.string()
    .required('Descrição obrigatória')
    .max(2000, 'Máximo de 2000 caracteres'),
  occurrenceType: Yup.object()
    .required('Tipo de ocorrência obrigatório')
    .typeError('Tipo de ocorrência obrigatório'),
});
